import Cookies from 'js-cookie';
import { ACCESWEB_NONPROD, ACCESWEB_PROD, isEnvNonProd } from '../config';

export const TNR_COOKIE = 'momentVerite';
export const DOMAIN_DESJARDINS_COOKIE = '.desjardins.com';
export const JWT_COOKIE_CONFIG_NAME = 'config';

const JWT_COOKIE_DESJ_NAME = 'DESJ_AWINFORMATIONNEL';
const TEST_JWT_KEY_NAME = 'com.desjardins.parcours-habitation.jwt';

export enum TNR_MOMENTVERITE_VALUES {
    NON_COMPLET = 'renouvellement_non_complete',
    COMPLET = 'renouvellement_complete'
}

export enum Langues {
    FR = 'fr',
    EN = 'en'
}

export function getFakeJWT(): string {
    return sessionStorage.getItem(TEST_JWT_KEY_NAME);
}

export function setJWT(token: string): void {
    sessionStorage.setItem(TEST_JWT_KEY_NAME, token);
}

export function deleteJWT(): void {
    sessionStorage.removeItem(TEST_JWT_KEY_NAME);
}

export const getCookieAttributes = (cookieName: string): any => {
    const cookie = Cookies.get(cookieName);
    if (cookie) {
        const decodedCookie = decodeURI(cookie);
        return JSON.parse(decodedCookie);
    }
    return null;
};

//eslint-disable-next-line
export const writeCookie = (cookie: any): void => {
    Cookies.withConverter({
        write: function (value) {
            return value;
        }
    }).set(JWT_COOKIE_CONFIG_NAME, encodeURIComponent(JSON.stringify(cookie)), {
        domain: DOMAIN_DESJARDINS_COOKIE
    });
};

export const setCookieConfig = (
    idDemande: string,
    langue: string,
    isApp: boolean,
    isNonProdEnv: boolean
): void => {
    const baseUrlRetour = isNonProdEnv ? ACCESWEB_NONPROD : ACCESWEB_PROD;
    const infoPret = '{"idDemande":' + idDemande + '}';

    const config = {
        infoPret: infoPret,
        langue: langue,
        urlRetour: baseUrlRetour + '/identifiantunique/sso/redirect',
        isApp: isApp
    };

    writeCookie(config);
};

export const setLangueInCookies = (langue: string): void => {
    const cookieConfigAttributes = getCookieAttributes(JWT_COOKIE_CONFIG_NAME);
    if (cookieConfigAttributes) {
        cookieConfigAttributes.langue = langue;
        //Write cookie
        writeCookie(cookieConfigAttributes);
    }

    return null;
};

export function isSimulateurOriginalSource(): boolean {
    const cookieConfigAttributes = getCookieAttributes(JWT_COOKIE_CONFIG_NAME);
    return cookieConfigAttributes && cookieConfigAttributes?.pdo != null;
}

export function getConfigCookie(): string {
    return Cookies.get(JWT_COOKIE_CONFIG_NAME);
}

// Used only for error banner
// Otherwise retrieve idDemande from /session call
export function getPretIdDemande(): string {
    const cookieConfigAttributes = getCookieAttributes(JWT_COOKIE_CONFIG_NAME);
    if (!cookieConfigAttributes) {
        return null;
    }
    // try to retrieve and parse infoPret information
    try {
        const infoPret = JSON.parse(cookieConfigAttributes?.infoPret);
        return infoPret?.idDemande;
    } catch (error) {
        return null;
    }
}
//eslint-disable-next-line
export function getLangueFromCookies() {
    const cookieConfigAttributes = getCookieAttributes(JWT_COOKIE_CONFIG_NAME);
    if (cookieConfigAttributes) {
        return cookieConfigAttributes?.langue;
    }

    return null;
}

export function getDesjLangueFromCookie(): string {
    const cookieAttributes = getCookieAttributes(JWT_COOKIE_DESJ_NAME);
    if (cookieAttributes) {
        if (cookieAttributes?.langue === Langues.FR) {
            return Langues.FR;
        } else if (cookieAttributes?.langue === Langues.EN) {
            return Langues.EN;
        }
    }
    return null;
}

export function isMobileAppFromCookies(): boolean {
    let isMobile = false;

    const cookieConfigAttributes = getCookieAttributes(JWT_COOKIE_CONFIG_NAME);
    if (cookieConfigAttributes) {
        isMobile = cookieConfigAttributes?.isApp;
    }

    return isMobile;
}

export function isNextReturnFromAssurance(): boolean {
    let isNextReturnFromAssurance = false;

    const cookieConfigAttributes = getCookieAttributes(JWT_COOKIE_CONFIG_NAME);
    if (cookieConfigAttributes) {
        isNextReturnFromAssurance =
            cookieConfigAttributes?.statutAssurance === 'NEXT';
    }

    return isNextReturnFromAssurance;
}

export function getRetourUrl(): string {
    const baseUrlRetour = isEnvNonProd() ? ACCESWEB_NONPROD : ACCESWEB_PROD;
    return baseUrlRetour + '/identifiantunique/sso/redirect';
}

export function deleteCookie(
    name: string,
    domaine: string,
    path: string
): void {
    Cookies.remove(name, { path: path, domain: domaine });
}
